import React, { useRef , useContext, useEffect } from 'react';
import {
  Marker,
  Popup,
  useMap
} from "react-leaflet";
import L from 'leaflet';
import { menu2icon } from './config';
import {Context} from "../../../store/reducer";

/**
 * 93: 各種法令の規制情報_建築基準法（指定道路図）用のポップアップ
 *
 *
 * @param spot
 * @param latitude
 * @param longitude
 * @param menu
 * @param draggable
 * @param option
 * @returns {JSX.Element|null}
 * @constructor
 */
const Component = ({id, latitude, longitude, menu, draggable=false, option}) => {

  const { state } = useContext(Context);
  const markerRef = useRef(null);
  
  useEffect(() => {
    
    // 変化があるごとにポップアップを自動表示
    if (markerRef.current) {
      markerRef.current.openPopup();
    }
  });
  
  const icon = menu2icon["vis_32"]

  const iconUrl = new L.Icon({
    iconUrl: icon,
    iconRetinaUrl: icon,
    iconSize: [35, 35],
    iconAnchor: [17, 23],
    popupAnchor: [0, -50]
  });

  const map = useMap()
  const bounds = map.getBounds()
  const minlat = bounds._southWest.lat
  const maxlat = bounds._northEast.lat
  const minlng = bounds._southWest.lng
  const maxlng = bounds._northEast.lng

  const handleSpotData = (id) => {

    let ret = []
    
    if (id === "vis_93_1") {
      ret.push(<h3>【第42条第1項第4号】</h3>)
    } else if (id === "vis_93_2") {
      ret.push(<h3>【第42条第1項第5号】</h3>)
    } else if (id === "vis_93_3") {
      ret.push(<h3>【第42条第2項】</h3>)
    }

    // データセットは3メニューで共通なので93_1として取得する。
    const dataset = state.data_for_90.data["vis_93_1"]

    if (dataset) {
      // レイヤー名を出力
      ret.push(<dl className='dl-list is-modal-spot'><dd><a href={dataset.url} target={"_blank"}>各種法令の規制情報、建築基準法(指定道路図)</a></dd></dl>)
    }

    ret.push(<p>法令名をクリックすると、建築基準法に規定する指定道路図及び指定道路調書の閲覧の確認画面に遷移します。</p>)

    return ret

  }

  if(latitude > minlat && latitude < maxlat && longitude > minlng && longitude < maxlng){

    return (
      <>
        <Marker
          position={[latitude, longitude]}
          icon={iconUrl}
          ref={markerRef}
        >
          <Popup minHeight={300} maxHeight={400} minWidth={500} closeOnClick>
            {
              handleSpotData(id)
            }
          </Popup>
        </Marker>

      </>
    );
  }else{
    return null
  }
}

export default Component;
